// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Setting: React.FC<SvgProps> = (props) => (
  <Svg {...props} width="22.621" height="23.995" viewBox="0 0 22.621 23.995">
    <path
      id="パス_73"
      data-name="パス 73"
      d="M23.245-13.191a1.062,1.062,0,0,1-.3,1.153l-2.03,1.847A9.07,9.07,0,0,1,21-9a9.07,9.07,0,0,1-.08,1.191l2.03,1.847a1.062,1.062,0,0,1,.3,1.153A11.619,11.619,0,0,1,22.5-3.2l-.22.38a11.928,11.928,0,0,1-1.036,1.463,1.062,1.062,0,0,1-1.148.319l-2.611-.83A9.02,9.02,0,0,1,15.427-.68L14.841,2a1.059,1.059,0,0,1-.853.834A12.112,12.112,0,0,1,12,3,12.112,12.112,0,0,1,10,2.831,1.059,1.059,0,0,1,9.15,2L8.564-.68A9.02,9.02,0,0,1,6.5-1.87L3.9-1.036a1.07,1.07,0,0,1-1.148-.319A11.928,11.928,0,0,1,1.711-2.817l-.22-.38A11.619,11.619,0,0,1,.75-4.8a1.062,1.062,0,0,1,.3-1.153L3.08-7.8A9.2,9.2,0,0,1,3-9a9.07,9.07,0,0,1,.08-1.191L1.05-12.037a1.062,1.062,0,0,1-.3-1.153A11.619,11.619,0,0,1,1.491-14.8l.22-.38a11.928,11.928,0,0,1,1.036-1.462A1.062,1.062,0,0,1,3.9-16.959l2.611.83A9.02,9.02,0,0,1,8.569-17.32L9.155-20a1.059,1.059,0,0,1,.853-.834A11.621,11.621,0,0,1,12-21a12.113,12.113,0,0,1,1.992.164,1.059,1.059,0,0,1,.853.834l.586,2.677a9.02,9.02,0,0,1,2.063,1.191l2.611-.83a1.07,1.07,0,0,1,1.148.319,11.928,11.928,0,0,1,1.036,1.462l.22.38A11.619,11.619,0,0,1,23.25-13.2ZM12-5.25A3.749,3.749,0,0,0,15.75-9,3.749,3.749,0,0,0,12-12.75,3.749,3.749,0,0,0,8.25-9,3.749,3.749,0,0,0,12-5.25Z"
      transform="translate(-0.687 21)"
    />
  </Svg>
);

Setting.displayName = 'Setting';

export default Setting;
